import { Appointment } from "@elixir/types";
import { ReactComponent as ArrowUpRightRegularIcon } from "../../../../assets/icons/font-awesome/arrow-up-right-regular.svg";
import { onReferAdocAction } from "../../../../utils/bridges/methods";
import { ChipWithTooltip } from "ui";

const ReferToDoctor = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  return (
    <ChipWithTooltip
      onClick={() => {
        onReferAdocAction(apt);
      }}
      className={`h-32 flex-1 ${className}`}
      icon={<ArrowUpRightRegularIcon className="dr-min-w-14 dr-h-14" />}
      title="Refer to Doctor"
      tooltipText="Refer to Doctor"
      type={type}
    />
  );
};

export default ReferToDoctor;
